// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '../outgoing-payment/types';

export function brazilianOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  const documentType = userInputValues['brazilianDocumentType'];

  let outgoingPayment = {
    country: 'br',
    document_type: userInputValues['brazilianDocumentType'],
    document: userInputValues['brazilianDocument'],
    zipcode: userInputValues['brazilianZipcode'],
    state: userInputValues['brazilianState'],
    city: userInputValues['brazilianCity'],
    address: userInputValues['brazilianAddress'],
    street_number: userInputValues['brazilianStreetNumber'],
    street_complement: userInputValues['brazilianStreetComplement'],
    phone_number: userInputValues['brazilianPhoneNumber'],
  };

  if (documentType === 'cnpj') {
    outgoingPayment = {
      ...outgoingPayment,
      person_type: 'business',
      responsible: {
        name: userInputValues['customerName'],
      },
    };
  }

  return outgoingPayment;
}
